import React from 'react';

interface SimpleGridLayoutProps {
  numColumns?: number;

  children: React.ReactNode;

  className?: string;
}

export const SimpleGridLayout = ({ numColumns, children, className = '' }: SimpleGridLayoutProps) => {
  const containerBaseClasses = 'flex flex-col gap-5';

  const containerResponsiveClasses = `sm:grid sm:gap-5 sm:items-stretch ${numColumns ? '' : 'sm:grid-cols-2'}`;

  const containerResponsiveStyle = numColumns ? { gridTemplateColumns: `repeat(${numColumns}, 1fr)` } : undefined;

  return (
    <div
      className={`${containerBaseClasses} ${containerResponsiveClasses} ${className}`.trim()}
      style={containerResponsiveStyle}
    >
      {children}
    </div>
  );
};
